/**
 * Constantes de datos estáticos BD
 */
const ConstantesBD = {
  SOLICITUD_ESTADO: {
    PENDIENTE: 1,
    EN_CURSO: 2,
    AUTORIZADA: 3,
    DENEGADA: 4,
    JUSTIFICADA: 5
  },
  ROLES:{
    ADMINISTRADOR: "ROLE_ADMIN"
  }
}
export default ConstantesBD
